(() => {
  const mq = window.matchMedia('(min-width: 990px)');
  const CLOSE_DELAY = 140;

  function init() {
    document.querySelectorAll('.pujh-mega-menu').forEach((details) => {
      if (details.dataset.pujhMegaReady === 'true') return;
      details.dataset.pujhMegaReady = 'true';
      let timer;

      const open = () => {
        if (!mq.matches) return;
        clearTimeout(timer);
        document.querySelectorAll('.pujh-mega-menu[open]').forEach((other) => {
          if (other !== details) other.removeAttribute('open');
        });
        details.setAttribute('open', '');
        const summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      };

      const close = () => {
        if (!mq.matches) return;
        clearTimeout(timer);
        timer = setTimeout(() => {
          details.removeAttribute('open');
          const summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, CLOSE_DELAY);
      };

      details.addEventListener('mouseenter', open);
      details.addEventListener('mouseleave', close);
      details.addEventListener('focusin', open);
      details.addEventListener('focusout', (event) => {
        if (!details.contains(event.relatedTarget)) close();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
